import React, { useEffect } from 'react'
import './SignUpBYODSetup.scoped.sass'
import store from '@/core/store'
import { ReactComponent as TadaIcon } from '@/assets/icons/tada.svg'

export function SignUpBYODSetup () {
  useEffect(() => {
    setTimeout(() => {
      store.commit('START_SIDE_MENU:VISIBILITY', false)
    }, 0)
  }, [])
  return <div className="waiting-page">
    <div className='tada-div'>
      <TadaIcon />
    </div>
    <div className="waiting-page-text">
      <div className="waiting-page-text-title">Our team has received your request for bringing your domain!</div>
      <div>
        Our team received your request and will be in contact with you as soon as possible
        in order to help you setting up your account and all the necessary resources.
      </div>
    </div>
  </div>
}
